module.exports = __webpack_public_path__ + "img/2recr_regioni.7e730225.png";